import { TypedDocumentNode, gql } from '@apollo/client';

import { withFragments } from 'lib/gql';
import { FragmentOf, unmaskFragment } from 'lib/graphql';

import { drawPlayerName_AnyCardInterface } from './__generated__/drawPlayerName.graphql';

export const drawPlayerName = withFragments(
  async ({
    ctx,
    card: card_,
    x,
    y,
    scale,
    fontName,
    fill = '#fff',
  }: {
    ctx: CanvasRenderingContext2D;
    card: FragmentOf<drawPlayerName_AnyCardInterface>;
    x: number;
    y: number;
    scale: number;
    fontName: string;
    fill?: string;
  }) => {
    const card = unmaskFragment(card_);
    ctx.textAlign = 'center';
    ctx.font = `bold ${35 * scale}px ${fontName}`;

    ctx.fillStyle = fill;
    ctx.fillText(card.anyPlayer.displayName.toLocaleUpperCase(), x, y);
  },
  {
    AnyCardInterface: gql`
      fragment drawPlayerName_AnyCardInterface on AnyCardInterface {
        slug

        anyPlayer {
          slug
          displayName
        }
      }
    ` as TypedDocumentNode<drawPlayerName_AnyCardInterface>,
  }
);
